import { render } from "./EditCollectionButton.vue.js?vue&type=template&id=b9c4c00e!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EditCollectionButton.vue?vue&type=template&id=b9c4c00e"
import script from "./EditCollectionButton.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EditCollectionButton.vue?vue&type=script&lang=js"
export * from "./EditCollectionButton.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EditCollectionButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/base-collection-card/EditCollectionButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b9c4c00e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b9c4c00e', __exports__)) {
    api.reload('b9c4c00e', __exports__)
  }
  
  module.hot.accept("./EditCollectionButton.vue.js?vue&type=template&id=b9c4c00e!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EditCollectionButton.vue?vue&type=template&id=b9c4c00e", () => {
    api.rerender('b9c4c00e', render)
  })

}


export default __exports__